import { commonActions as enActions } from "./i18n/features/en/common-actions";
import { commonFields as enFields } from "./i18n/features/en/common-fields";
import { commonMessages as enMessages } from "./i18n/features/en/common-messages";
import { commonNouns as enNouns } from "./i18n/features/en/common-nouns";
import { commonPlaceholders as enPlaceholders } from "./i18n/features/en/common-placeholders";
import { commonActions as jaActions } from "./i18n/features/ja/common-actions";
import { commonFields as jaFields } from "./i18n/features/ja/common-fields";
import { commonMessages as jaMessages } from "./i18n/features/ja/common-messages";
import { commonNouns as jaNouns } from "./i18n/features/ja/common-nouns";
import { commonPlaceholders as jaPlaceholders } from "./i18n/features/ja/common-placeholders";
import { commonActions as zhActions } from "./i18n/features/zh/common-actions";
import { commonFields as zhFields } from "./i18n/features/zh/common-fields";
import { commonMessages as zhMessages } from "./i18n/features/zh/common-messages";
import { commonNouns as zhNouns } from "./i18n/features/zh/common-nouns";
import { commonPlaceholders as zhPlaceholders } from "./i18n/features/zh/common-placeholders";
import {
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  normalizeLocale,
} from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": {
    common: {
      actions: zhActions,
      fields: zhFields,
      messages: zhMessages,
      nouns: zhNouns,
      placeholders: zhPlaceholders,
    },
  },
  en: {
    common: {
      actions: enActions,
      fields: enFields,
      messages: enMessages,
      nouns: enNouns,
      placeholders: enPlaceholders,
    },
  },
  ja: {
    common: {
      actions: jaActions,
      fields: jaFields,
      messages: jaMessages,
      nouns: jaNouns,
      placeholders: jaPlaceholders,
    },
  },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";
